// src/components/invitations/ManualEntryForm.tsx
import React, { useState } from 'react';
import SparkButton from '../common/SparkButton';
import SparkInput from '../common/SparkInput';

interface ManualEntryFormProps {
  onAddRecipient: (recipient: { name: string; email?: string; phone?: string }) => void;
}

const ManualEntryForm: React.FC<ManualEntryFormProps> = ({ onAddRecipient }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState<string | null>(null);

  // Simple email and phone validators
  const validateEmail = (email: string) => {
    return /^\S+@\S+\.\S+$/.test(email);
  };

  const validatePhone = (phone: string) => {
    return /^[0-9\-+\(\)\s]+$/.test(phone);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);

    // Basic checks
    if (!name || (!email && !phone)) {
      setError('Name and either Email or Phone are required.');
      return;
    }

    if (email && !validateEmail(email)) {
      setError('Invalid email format.');
      return;
    }

    if (phone && !validatePhone(phone)) {
      setError('Invalid phone format.');
      return;
    }

    // Pass the data up
    onAddRecipient({ name, email, phone });

    // Reset form
    setName('');
    setEmail('');
    setPhone('');
  };

  return (
    <div style={{ width: '100%', boxSizing: 'border-box' }}>
      {error && (
        <div className="spark-message spark-message--error">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ width: '100%', boxSizing: 'border-box' }}>
        <SparkInput
          label="Name"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter recipient name"
        />

        <SparkInput
          label="Email"
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter recipient email"
        />

        <SparkInput
          label="Phone"
          id="phone"
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Enter recipient phone"
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <SparkButton type="submit">
            Add Recipient
          </SparkButton>
        </div>
      </form>
    </div>
  );
};

export default ManualEntryForm;